import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay02 from "./../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import MainBtn from "./../../components/atoms/button/mainBtn";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import SelectBox from "../../components/organisms/SelectBox";
import InputField from "../../components/atoms/input/inputField";
import MOContainer from "../../components/atoms/layout/moContainer";
import { activitySubTabList, tabList } from "../../constant/myPageTab";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import ReviewApi from "../../api/review.api";
import { fileUrl } from "../../api/api";
import { toast } from "react-toastify";
import { macOSCheck } from "../../util/macOSCheck";
import { errorHandler } from "../../util/errorHandler";
import Loading from "../../components/templates/loading";
import { route } from "../../router/route";

const MyPageActivityReviewEdit = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { id } = useParams();
  const userId = sessionStorage.getItem("id");
  const [isLoading, setIsLoading] = useState(true);

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[1].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    activitySubTabList[2].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          `${route.my_page_activity_review_edit}/${id}`,
        )}`,
        { replace: true },
      );
      return;
    }

    if (!Number.isInteger(Number(id)) || Number(id) <= 0) {
      navigate(route.my_page_activity_review, { replace: true });
      return;
    }

    getReviewData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 리뷰 데이터 가져오기 ---------- //
  const [reviewData, setReviewData] = useState({});

  const getReviewData = async () => {
    try {
      const response = (await ReviewApi.getDetail(id)).data.data.content;

      setReviewData(response);

      // URL 입력으로 접근 시, 본인의 후기가 아닌 경우 이전 페이지로 이동
      if (Number(userId) !== response?.member?.id) {
        toast("본인이 작성한 후기만 수정할 수 있습니다.");
        navigate(route.my_page_activity_review, { replace: true });
        return;
      }

      if (response.score === 1) {
        setSelectedReviewRating("1점");
      } else if (response.score === 2) {
        setSelectedReviewRating("2점");
      } else if (response.score === 3) {
        setSelectedReviewRating("3점");
      } else if (response.score === 4) {
        setSelectedReviewRating("4점");
      } else if (response.score === 5) {
        setSelectedReviewRating("5점");
      }
    } catch (error) {
      errorHandler(error);
      navigate(route.my_page_activity_review, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- 리뷰 점수 관련 ---------- //
  const [reviewRatingBoxOpen, setReviewRatingBoxOpen] = useState(false);
  const [selectedReviewRating, setSelectedReviewRating] = useState("별점");

  const reviewRatingList = [
    { title: "1점", value: "1점" },
    { title: "2점", value: "2점" },
    { title: "3점", value: "3점" },
    { title: "4점", value: "4점" },
    { title: "5점", value: "5점" },
  ];

  // ---------- 리뷰 수정하기 ---------- //
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReviewEdit = async () => {
    if (isSubmitting) return;

    try {
      const title = reviewData?.title?.trim();
      const content = reviewData?.content?.trim();

      if (!title) {
        toast("제목을 입력해 주세요.");
        return;
      }

      if (!content) {
        toast("내용을 입력해 주세요.");
        return;
      }

      setIsSubmitting(true);
      const data = {
        score: reviewData.score,
        title,
        content,
      };

      if (selectedReviewRating === "1점") {
        data.score = 1;
      } else if (selectedReviewRating === "2점") {
        data.score = 2;
      } else if (selectedReviewRating === "3점") {
        data.score = 3;
      } else if (selectedReviewRating === "4점") {
        data.score = 4;
      } else if (selectedReviewRating === "5점") {
        data.score = 5;
      }

      await ReviewApi.update(id, data);
      toast("후기가 수정되었습니다.");
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <HeaderContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <LSRgDisplay02 style={{ color: "#000" }}>후기 수정</LSRgDisplay02>
              <LSRgH2HeadLine style={{ color: "#000" }}>
                이용 정책에 어긋나는 후기는 삭제 처리될 수 있어요.
              </LSRgH2HeadLine>
            </div>
            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 6.5,
              }}
            >
              <MainBtn
                disabled={isSubmitting}
                style={{
                  background: "#fff",
                  height: 36,
                  width: 72,
                }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#A4A8B1",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  취소
                </LSRgBody01>
              </MainBtn>
              <MainBtn
                disabled={isSubmitting}
                style={{
                  height: 36,
                  width: 72,
                }}
                onClick={() => {
                  handleReviewEdit();
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#fff",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  {isSubmitting ? "수정 중..." : "등록"}
                </LSRgBody01>
              </MainBtn>
            </div>
          </HeaderContainer>

          {/* 본문 영역 */}
          <BodyContainer>
            {/* 본문 영역 - 강의 정보 */}
            <LectureContainer>
              <LectureContentImg
                src={
                  reviewData?.lecture?.thumbnailServerFileName
                    ? `${fileUrl}/${reviewData?.lecture?.thumbnailServerFileName}`
                    : ""
                }
                alt="콘텐츠 썸네일"
              />
              <LectureContentWrapper>
                <LSBdDisplay02>
                  {reviewData?.lecture?.title || ""}
                </LSBdDisplay02>
                <LectureContentTextContainer>
                  <LectureContentTextWrapper>
                    <LSBdH1HeadLine style={{ color: "#898E99" }}>
                      수강기간
                    </LSBdH1HeadLine>
                    <LSRgH1HeadLine stye={{ color: "#000" }}>
                      {!reviewData?.lectureVideoFlag && "무제한"}
                      {reviewData?.lectureVideoFlag &&
                        `${reviewData?.lecture?.period || 0}일`}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                  {reviewData.lectureVideoFlag && (
                    <LectureContentTextWrapper>
                      <LSBdH1HeadLine style={{ color: "#898E99" }}>
                        커리큘럼
                      </LSBdH1HeadLine>
                      <LSRgH1HeadLine stye={{ color: "#000" }}>
                        총 {reviewData?.lecture?.curriculumCount || 0}강
                      </LSRgH1HeadLine>
                    </LectureContentTextWrapper>
                  )}
                  <LectureContentTextWrapper>
                    <LSBdH1HeadLine
                      style={{
                        color: "#898E99",
                        letterSpacing: 6,
                        width: 55,
                      }}
                    >
                      강사명
                    </LSBdH1HeadLine>
                    <LSRgH1HeadLine stye={{ color: "#000" }}>
                      {reviewData?.lecture?.instructorName || ""}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                </LectureContentTextContainer>
              </LectureContentWrapper>
            </LectureContainer>

            {/* 본문 영역 - 별점 및 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <SelectBox
                isSmall={true}
                selectedValue={selectedReviewRating}
                isOpen={reviewRatingBoxOpen}
                wrapperHandler={() => {
                  setReviewRatingBoxOpen(!reviewRatingBoxOpen);
                }}
                itemList={reviewRatingList}
                selectedValueSetterFunc={setSelectedReviewRating}
              />
              <InputField
                id="title"
                name="title"
                placeholder="후기 제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={reviewData?.title || ""}
                onChange={(e) => {
                  setReviewData({
                    ...reviewData,
                    title: e.target.value,
                  });
                }}
                containerStyle={{
                  width: 1005,
                }}
              />
            </div>

            {/* 본문 영역 - 내용 입력 */}
            <Textarea
              name="content"
              placeholder="후기를 입력해 주세요."
              value={reviewData?.content || ""}
              onChange={(e) => {
                setReviewData({
                  ...reviewData,
                  content: e.target.value,
                });
              }}
            />
          </BodyContainer>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={activitySubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                marginBottom: 20,
              }}
            >
              <LSRgH1HeadLine style={{ color: "#000" }}>
                후기 수정
              </LSRgH1HeadLine>
              <LSRgCaption02 style={{ color: "#898e99" }}>
                이용 정책에 어긋나는 후기는 삭제 처리될 수 있어요.
              </LSRgCaption02>
            </div>

            {/* 본문 영역 - 별점 및 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <SelectBox
                isSmall={true}
                style={{
                  width: 158,
                }}
                subMenuStyle={{
                  width: 158,
                }}
                selectedValue={selectedReviewRating}
                isOpen={reviewRatingBoxOpen}
                wrapperHandler={() => {
                  setReviewRatingBoxOpen(!reviewRatingBoxOpen);
                }}
                itemList={reviewRatingList}
                selectedValueSetterFunc={setSelectedReviewRating}
              />

              <InputField
                isSmall={true}
                id="title"
                name="title"
                placeholder="후기 제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={reviewData?.title || ""}
                onChange={(e) => {
                  setReviewData({
                    ...reviewData,
                    title: e.target.value,
                  });
                }}
              />
              {/* 본문 영역 - 내용 입력 */}
              <Textarea
                name="content"
                placeholder="후기를 입력해 주세요."
                value={reviewData?.content || ""}
                onChange={(e) => {
                  setReviewData({
                    ...reviewData,
                    content: e.target.value,
                  });
                }}
              />

              <div
                style={{
                  display: "flex",
                  gap: 10,
                }}
              >
                <MainBtn
                  disabled={isSubmitting}
                  style={{
                    background: "#f6f7f8",
                    width: 164,
                    height: 46,
                  }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#A4A8B1",
                      textAlign: "center",
                    }}
                  >
                    취소
                  </LSRgBody01>
                </MainBtn>
                <MainBtn
                  disabled={isSubmitting}
                  style={{
                    width: 164,
                    height: 46,
                  }}
                  onClick={() => {
                    handleReviewEdit();
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    {isSubmitting ? "수정 중..." : "등록"}
                  </LSRgBody01>
                </MainBtn>
              </div>
            </div>

            {/* 본문 영역 - 강의 정보 */}
            <LectureContainer $isSmall={isSmall} style={{ marginTop: 16 }}>
              <LectureContentImg
                $isSmall={isSmall}
                src={
                  reviewData?.lecture?.thumbnailServerFileName
                    ? `${fileUrl}/${reviewData?.lecture?.thumbnailServerFileName}`
                    : ""
                }
                alt="콘텐츠 썸네일"
              />
              <LectureContentWrapper $isSmall={isSmall}>
                <LSBdH1HeadLine>
                  {reviewData?.lecture?.title || ""}
                </LSBdH1HeadLine>
                <LectureContentTextContainer $isSmall={isSmall}>
                  <LectureContentTextWrapper>
                    <LSBdBody01 style={{ color: "#898E99" }}>
                      수강기간
                    </LSBdBody01>
                    <LSRgH1HeadLine>
                      {" "}
                      {!reviewData?.lectureVideoFlag && "무제한"}
                      {reviewData?.lectureVideoFlag &&
                        `${reviewData?.lecture?.period || 0}일`}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                  {reviewData.lectureVideoFlag && (
                    <LectureContentTextWrapper>
                      <LSBdBody01 style={{ color: "#898E99" }}>
                        커리큘럼
                      </LSBdBody01>
                      <LSRgH1HeadLine>
                        {" "}
                        총 {reviewData?.lecture?.curriculumCount || 0}강
                      </LSRgH1HeadLine>
                    </LectureContentTextWrapper>
                  )}
                  <LectureContentTextWrapper>
                    <LSBdBody01
                      style={{
                        color: "#898E99",
                        letterSpacing: 6,
                        width: 50,
                      }}
                    >
                      강사명
                    </LSBdBody01>
                    <LSRgH1HeadLine>
                      {reviewData?.lecture?.instructorName || ""}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                </LectureContentTextContainer>
              </LectureContentWrapper>
            </LectureContainer>
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageActivityReviewEdit;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${(props) =>
    props.$isSmall ? "" : "rgba(237, 237, 255, 0.5)"};
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const HeaderContainer = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const BodyContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: fit-content;
  gap: 20px;
`;

const LectureContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 20px;
  padding: ${(props) => (props.$isSmall ? "20px" : "40px")};
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "20px" : "30px")};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
`;

const LectureContentImg = styled.img.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "295px" : "278px")};
  height: ${(props) => (props.$isSmall ? "187px" : "177px")};
  object-fit: cover;
  border-radius: 15px;
`;

const LectureContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "10px" : "30px;")};
`;

const LectureContentTextContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "4px" : "8px")};
`;

const LectureContentTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  height: 22px;
`;

const Textarea = styled.textarea.attrs((props) => {})`
  width: 100%;
  height: 700px;
  padding: 17px 15px;
  background-color: #fff;
  border: 1px solid #dbdde0;
  border-radius: 15px;
  resize: none;

  font-family: "LINESeedKR-Rg";
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.6px;
  color: #000;

  &::placeholder {
    color: #a4a8b1;
  }

  &:focus {
    outline: none;
  }
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;
